import { schema } from "normalizr";
import { gameEntity } from "./game";
import { questionEntity } from "./question";

export const submissionEntity = new schema.Entity("submissions", {
  gameId: gameEntity,
  questionId: questionEntity,
});
